// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-297cc108] .el-table{overflow:visible!important}.font[data-v-297cc108]{color:red;margin:0 5px}.dialog-tab-footer[data-v-297cc108]{text-align:right;margin:20px 0}", ""]);
// Exports
module.exports = exports;
